@if (variant === 'static') {
  <h2 class="text-uppercase fw-bold h5 pb-4" data-test-id="app-auto-vision-equipment-accessories-e-header">{{autoVisionEquipmentAccessoriesTranslations.optionsAndAccessories}}</h2>
}
<app-options-accessories
  [optionAccessories]="autoVisionEquipmentAccessoriesTranslations.dataObject"
  [longDescriptions]="longDescriptions$ | async"
  [options]="options$ | async"
  [variant]="variant"
  [limit]="maxEquipRows">
</app-options-accessories>
